import * as React from "react";
import Button from "@mui/material/Button";
import { CODES } from "../../consts/codes";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Avatar, Grid, Box } from "@mui/material";
import { useNavigate } from "react-router";
import { LogoutService, SupportLogoutService } from "../../services/auth/authServices";
import { useTranslation } from "react-i18next";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../pages/userSlice";
import LoginIcon from "@mui/icons-material/Login";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SettingsIcon from "@mui/icons-material/Settings";
import { useEffect, useRef, useState } from "react";
import { resetCurrentCompany } from "../../parts/listUsers/listUsersSlice";

/**
 * Componente ButtonLogOut para botón de cierre de sesión.
 */
export default function ButtonLogOut() {
  const { t } = useTranslation();
  const [isDesktop, setDesktop] = useState(window.innerWidth > 768);
  const [isTablet, setTablet] = useState(window.innerWidth > 696);

  const [isOpen, setIsOpen] = useState(false);
  const [buttonWidth, setButtonWidth] = useState(0);
  const buttonRef = useRef(null);

  /** Actualiza los estados responsivos según el ancho de la ventana. */
  const updateMedia = () => {
    setDesktop(window.innerWidth > 890);
    setTablet(window.innerWidth > 696);
  };

  const dispatch = useDispatch();

  /** Efecto para actualizar los estados responsivos al cambiar el tamaño de la ventana. */
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, []);

  /** Efecto para ajustar el ancho del botón según su contenido. */
  useEffect(() => {
    if (buttonRef.current) {
      const width = buttonRef.current.offsetWidth;
      setButtonWidth(width < 210 ? 210 : width);
    }
  }, [isOpen]);

  const userInfo = useSelector(getUser);
  /** Alterna la visibilidad del menú desplegable. */
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  /**
   * Función que redirecciona a la vista de ayuda al usuario
   */
  const handleNavigateHelpCenter = () => {
    const jwtTokenInfo = localStorage.getItem("infoToken");
    if (jwtTokenInfo) {
      const jwtDecodeTokenInfo = jwt_decode(jwtTokenInfo);
      const user = jwtDecodeTokenInfo["custom:Role"];

      navigate(`/${user}/helpCenter`);
    }
  };

  const navigate = useNavigate();

  const jwtTokenInfo = localStorage.getItem("infoToken");
  let role = "";
  if (jwtTokenInfo) {
    const jwtDecodeTokenInfo = jwt_decode(jwtTokenInfo);
    role = jwtDecodeTokenInfo["custom:Role"];
  }

  const handleLogOut = async () => {
    try {
      if (userInfo?.support === "Y") {
        await SupportLogoutService({
          eanCompany: userInfo.eanCompanyMain,
          nameCompany: userInfo.eanCompanyMain,
          country: userInfo.country,
          email: userInfo.email,
        });
      }

      const service = await LogoutService();

      if (service.status === CODES.COD_RESPONSE_HTTP_OK) {
        if (
          service.data.responseCode === CODES.COD_RESPONSE_SUCCESS_REQUEST ||
          service.data.responseCode === CODES.COD_RESPONSE_HTTP_BAD_REQUEST
        ) {
          dispatch(resetCurrentCompany());
          sessionStorage.clear();
          localStorage.clear();

          navigate("/");
        }
      }
    } catch (error) {
      //TODO: Falta implementar inserción de log en dynamodb
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <Button
        ref={buttonRef}
        disableRipple
        variant="contained"
        onClick={handleClick}
        sx={{
          border: "none !important",
          boxShadow: "2px 2px 2px  #E0E0E066 !important",
        }}
      >
        <Grid container direction="row" spacing={1} className="step-1">
          <Grid item className="col-flex">
            <Avatar
              sx={{
                bgcolor: "#F0ECFF",
                color: "#553AB6",
                fontSize: isDesktop ? 18 : 14, // Tamaño de fuente reducido en mobile
                width: isDesktop ? 40 : 30, // Ancho reducido en mobile
                height: isDesktop ? 40 : 30, // Altura reducida en mobile
              }}
            >
              {role === "admin"
                ? "A"
                : userInfo &&
                  userInfo.firstName &&
                  userInfo.lastName &&
                  `${userInfo.firstName[0]}${userInfo.lastName[0]}`}
            </Avatar>
          </Grid>
          {isDesktop ? (
            <Grid item className="col-flex">
              {role === "admin"
                ? t("App.roles.admin")
                : userInfo &&
                  userInfo.firstName &&
                  userInfo.lastName &&
                  `${userInfo.firstName} ${userInfo.lastName}`}
            </Grid>
          ) : (
            <></>
          )}
          <Grid item className="col-flex">
            <ExpandMoreIcon sx={{ fontSize: 20 }} />
          </Grid>
        </Grid>
      </Button>

      {isOpen && (
        <Box
          sx={{
            position: "absolute",
            top: "100%",
            left: isDesktop ? 0 : `calc(100% - ${buttonWidth}px)`,
            bgcolor: "background.paper",
            boxShadow: 1,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: "12px",
            borderBottomRightRadius: "12px",
            zIndex: 1,
            width: buttonWidth,
            padding: 1,
          }}
        >
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
            className="logout_container"
            width={"100%"}
          >
            <Grid item>
              <p className="logout_container__textTitle">
                {role === "admin"
                  ? t("App.roles.admin")
                  : userInfo && userInfo.firstName + " " + userInfo.lastName}
              </p>
            </Grid>
            <Grid
              item
              pr={1}
              sx={{
                padding: "1rem 0rem 0.5rem 0.8rem  !important",
                width: "100%",
              }}
            >
              <p className="logout_container__text">{userInfo && userInfo.email}</p>
            </Grid>
            <Grid item>
              <p className="logout_container__text__two">
                {userInfo && userInfo.company && userInfo.company.companyName}
              </p>
            </Grid>
            {!isTablet && (
              <Grid item xl={2.2} lg={3} sm={5} xs={12} width={"100%"}>
                <Button
                  className="btn__filled__light-blue full-width"
                  sx={{
                    borderRadius: "8px",
                    minHeight: "39px",
                    minWidth: "140px",
                  }}
                  startIcon={<SupportAgentIcon />}
                  onClick={handleNavigateHelpCenter}
                >
                  {t("App.helpCenter.helpButton")}
                </Button>
              </Grid>
            )}
            <Grid
              item
              sx={{
                width: "100%",
                padding: "1%",
                marginTop: "2%",
                marginBottom: "2%",
              }}
            >
              <hr style={{ color: "#E0E0E0 !important" }} />
            </Grid>
            <Grid item sx={{ marginLeft: "2.5px" }}>
              <Button
                className="btn__logout"
                startIcon={<SettingsIcon sx={{ color: "#553AB6" }} />}
              >
                {t("App.navBar.settings")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="btn__logout"
                startIcon={<LoginIcon sx={{ color: "#553AB6" }} />}
                onClick={handleLogOut}
              >
                {t("App.navBar.logOut")}
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  );
}